import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
@Pipe({
    name: 'boostRename',
    standalone: false
})
export class BoostRenamePipe implements PipeTransform {
  static isEnabledForClient = new BehaviorSubject(true);
  static tooltipClass = new BehaviorSubject('tooltip offer-more-breakdown-tooltip');
  private static readonly offerMoreTooltipText =
  `Improve the likelihood of your shift being filled by increasing the hourly rate.

  Our Offer More Pricing Breakdown:
  • 78% of the Bill Rate = The IntelyPro Hourly Rate + Payroll Taxes & Expenses.
  • 22% of the Bill Rate = IntelyCare's costs which include recruiting, credentialing, clinical, and operational support.`;
  static tooltipText = new BehaviorSubject(BoostRenamePipe.offerMoreTooltipText);
  private readonly textMap = new Map<string, string>([
    ['Rate Boost','Offer More'],
    ['Overtime Boost','Offer Overtime'],
    ['Sure Shift Boost', 'Offer Sure Shift'],
    ['Boost Amount','Offer Amount'],
    ['Boost Pending', 'Offer Pending'],
    ['Boost Shift', 'Offer More'],
    ['Boost all', 'Offer More for all'],
    ['boosting', 'increasing'],
    ['Boost ', ''],
    ['Cannot boost the shift in the past', 'Cannot offer more on the shift in the past'],
    ['Boost block bookings from the Dashboard', 'Offer More on block bookings from the Dashboard'],
    ['Cannot be boosted because billing rate has been updated', 'Cannot offer more because billing rate has been updated'],
    ['Boost your shifts', 'Offer More'],
    ['using our boost options', 'offering more for the shift(s)'],
    ['Boosted Shifts', 'Offers'],
    ['Pending Boosted Shifts', 'Pending Offers'],
    ['boosted shifts pending', 'offers pending'],
    ['boost', 'offer more'],
    ['boost shift', 'offer more'],
    ['boost block booking', 'offer more'],
    ['Boost Block Booking', 'Offer More'],
    ['BOOST', 'OFFER'],
    ['Boost', 'Offer More'],
    ['Boosted Rate', 'Offer More Rate'],
    ['Boost request approved.', 'Offer request approved.'],
    ['Boost Your Shift(s)', 'Offer More'],
    ['Modify Boost', 'Modify Offer'],
    ['Boosting IntelyPro Request', 'Offering More for IntelyPro Request'],
    ['Boost in progress', 'Offer More in progress'],
    ['Boosted', ''],
    // ['', ''],
  ]);

  transform(value: any) {
    return this.renderText(value);
  }

  public renderText(key: string): string {
    return this.textMap.get(key) ?? key;
  }
}
